// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uUyZAC69lswUKyOMPxVB{cursor:pointer;background:0 0;border:none;border-radius:6px;outline:none;grid-template-columns:max-content 1fr max-content;place-items:center flex-start;gap:4px;width:100%;height:32px;padding:4px;display:grid}.uUyZAC69lswUKyOMPxVB:hover{background-color:var(--background-neutral-subtle)}.BR1Ht7zll7I1517HjPaG{place-items:center;width:24px;height:24px;display:flex}.QMHcQJKQ5wE63pvYxb_x{color:var(--content-primary-primary);align-items:center;gap:8px;display:flex}.ubVul5wr1ASVAkhXv1fY{color:var(--content-brand-primary);margin-right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `uUyZAC69lswUKyOMPxVB`,
	"wrapPlay": `BR1Ht7zll7I1517HjPaG`,
	"wrapName": `QMHcQJKQ5wE63pvYxb_x`,
	"check": `ubVul5wr1ASVAkhXv1fY`
};
export default ___CSS_LOADER_EXPORT___;
